exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-coupon .delete-content[data-v-6f37e464]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.delete-coupon .delete-content .delete-icon[data-v-6f37e464]{color:#f56c6c;font-size:5rem;margin-right:10px}", ""]);

// exports
